import src from "IMAGE";
export default { src, width: 227, height: 24, blurWidth: 0, blurHeight: 0};
